import "antd/dist/antd.min.css";
import "./App.css";
import { useLocation } from "react-router-dom";

import NewHeader from "./NewComponents/NewLayout/NewHeader";
import NewBottomNav from "./NewComponents/NewLayout/NewBottomNav";
import NewPageRouts from "./NewPages/NewPageRouts";

function App() {
  const location = useLocation();

  // ❌ jin routes pe header/footer nahi chahiye
  const hideLayoutRoutes = ["/login"];

  const hideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <div>
      {/* Header */}
      {!hideLayout && <NewHeader />}

      {/* Pages */}
      <NewPageRouts />

      {/* Bottom Nav */}
      {!hideLayout && <NewBottomNav />}
    </div>
  );
}

export default App;